
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51Ijoi4LmA4Lih4LiZ4Li5In0%3D!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51Ijoi4LmA4Lih4LiZ4Li5In0%3D!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51Ijoi6YG45ZauIn0%3D!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51Ijoi6YG45ZauIn0%3D!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51Ijoi4LmA4Lih4LiZ4Li5In0%3D!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51Ijoi4LmA4Lih4LiZ4Li5In0%3D!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiTWVudSJ9!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51Ijoi6YG45ZauIn0%3D!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51Ijoi6YG45ZauIn0%3D!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiW%2BG5guG6veG6veC4geC4teC5iceax5pdIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNZW51IjoiW%2BG5guG6veG6veC4geC4teC5iceax5pdIn0%3D!"
        )
      )
      });
  
      export { translations as translations };
    